import { FETCH_EMPLOYEES_FAILURE, FETCH_EMPLOYEES_REQUEST, FETCH_EMPLOYEES_SUCCESS } from "./actionType";

// reducer.js
const initialState = {
    employees: [],
    loading: false,
    error: null
  };
  
  export const fetchEmployeeReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_EMPLOYEES_REQUEST:
        return {
          ...state,
          loading: true,
          error: null
        };
      
      case FETCH_EMPLOYEES_SUCCESS:
        return {
          ...state,
          loading: false,
          employees: action.payload,
          error: null
        };
      
      case FETCH_EMPLOYEES_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload
        };
      
      default:
        return state;
    }
  };